import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/** Fetch clinic-ops clinical history (Rx + investigations per visit). */
export async function fetchPatientClinicalHistory(patientId) {
  const { data } = await axios.get(
    `${API}/api/clinic-ops/patients/${patientId}/history`,
    { withCredentials: true },
  );
  return data?.visits || [];
}

/** Fetch completed appointment visits for milestone Visit History. */
export async function fetchPatientVisits(patientId, { visitType } = {}) {
  const params = { include: 'completed', limit: 300 };
  if (visitType) params.visit_type = visitType;
  const { data } = await axios.get(
    `${API}/api/appointments/patient/${patientId}/visits`,
    { params, withCredentials: true },
  );
  return Array.isArray(data) ? data : [];
}

export async function fetchConsultationAuditLog(consultationId) {
  const { data } = await axios.get(
    `${API}/api/consultations/${consultationId}/audit-log`,
    { withCredentials: true },
  );
  return Array.isArray(data) ? data : [];
}

/** Hook: load clinical history when drawer opens. */
export function usePatientClinicalHistory(patientId, open) {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !patientId) return undefined;
    let cancelled = false;
    setLoading(true);
    fetchPatientClinicalHistory(patientId)
      .then((rows) => { if (!cancelled) setVisits(rows); })
      .catch(() => { if (!cancelled) setVisits([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [open, patientId]);

  return { visits, loading };
}
